import React from 'react';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { useTranslation } from 'react-i18next';
import { VerticallyAlignedBlogCardsWithShapedImage } from './components';
import { Helmet } from 'react-helmet';
import useCertificateData from 'Hooks/useCertificateData';

const Certificates = () => {
  const { t } = useTranslation();
  const {
    data: certificateData = [],
    error,
    execute,
  } = useCertificateData('certificate');

  return (
    <Main>
      <Helmet>
        <title>{t('topbar.pages.support.certificates')}</title>
      </Helmet>
      <Container>
        <VerticallyAlignedBlogCardsWithShapedImage
          certificateData={certificateData}
          error={error}
          onRetry={() => execute()}
        />
      </Container>
    </Main>
  );
};

export default Certificates;
